import axios from "@/api/config_java";

export default {
  /**
   * 获取建议列表
   * @param {*} params
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  guidancesList(params) {
    return axios.get("/am/api/alm/guidancesList", {
      params,
    });
  },

  /**
   * Facebook 账户异常消耗
   * @param {*} params
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  accountEarlyWarningList(params) {
    return axios.get("/am/api/accountEarlyWarning/list", {
      params,
    });
  },

  /**
   * 获取建议详情
   * @param {{accountId:string;pageNum:number;pageSize:number;objectLevel:string;orderBy:string}} params
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  guidancesDetail(params) {
    return axios.get("/am/api/alm/guidancesDetail", { params });
  },

  /**
   * 更新点击次数
   * @param {{adObjectId?:string;guidanceId?:string}} params
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  updateSuggClickCount(params) {
    return axios.post("/am/api/alm/updateSuggClickCount", params);
  },

  /**
   * 获取图片详细地址
   * @param shortLink
   * @returns {Promise<{code:number;data:{detailUrl:string}[];msg:string}>}
   */
  getDetailUrl(shortLink) {
    return axios.get("/am/api/alm/getDetailUrl", {
      params: {
        shortLink,
      },
    });
  },
  /**
   * 新增推销记录
   * @param {{accountId:string; guidanceName:string;adObjectId:string;guidanceId:string}} query
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  addPitchRecord(query){
    return axios.post('/am/api/alm/addPitchRecord',query)
  },
  /**
   * 首页展示建议详情
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  dynamicGuidanceList(){
    return axios.get('/am/api/alm/dynamicGuidanceList')
  },

  /**
   * 优化建议列表-按广告账户展示
   * @param query
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  guidancesAccountList(query){
    return axios.get('/am/api/alm/guidancesAccountList', {
      params: {
        ...query,
      }
    })
  }
};
